import { useParams } from "react-router-dom";
import videos from "./data.json"
import ReactPlayer from "react-player"

const WatchVideo = () => {

    const { id } = useParams();

    const activeVideo = videos.find(video => video.id == id);

    return (
        <div className="repo-details">
            <iframe width="1356" height="763" 
                src={activeVideo.url} title={activeVideo.title} frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            
        </div>
    );
}

export default WatchVideo;